import { Component,Output, Input, EventEmitter, OnInit } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';

@Component({
  selector: 'app-gestiones-productos',
  templateUrl: './gestiones-productos.component.html',
  styleUrls: ['./gestiones-productos.component.scss']
})
export class GestionesProductosComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService;
  ProductoSeleccionado;
  clientData: any = {};
  constructor() {
    setTimeout(() => {
      this.ProductoSeleccionado = this.clienteserviceParam.productoDetalleSelected;
    }, 800);
  }

  ngOnInit(): void {
    this.clientData =  this.clienteserviceParam.flowType === 'DEBTOR'
      ? this.clienteserviceParam.datosCliente : this.clienteserviceParam.datosCodeudor;
  }
  goBack() {
    this.selecttab.emit(16)//productos generales
  }
}
